import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusProgramDashboardQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID'];
  range: Types.EpocusStatsRangeInput;
}>;


export type EpocusProgramDashboardQuery = { readonly __typename?: 'Query', readonly epocusProgramDashboard: { readonly __typename?: 'EpocusProgramDashboard', readonly programId: string, readonly turnaroundTargetMinutes?: number | null, readonly qaReviewedCount: number, readonly qaReviewedPct?: number | null, readonly completedWithinTargetPct?: number | null, readonly openPastTargetCount: number, readonly range: { readonly __typename?: 'EpocusStatsRange', readonly from: string, readonly to: string }, readonly priorRange: { readonly __typename?: 'EpocusStatsRange', readonly from: string, readonly to: string }, readonly scans: { readonly __typename?: 'EpocusStatsDelta', readonly current: number, readonly prior: number, readonly deltaPct?: number | null }, readonly weekly: ReadonlyArray<{ readonly __typename?: 'EpocusProgramWeekPoint', readonly weekStart: string, readonly scans: number, readonly reviewed: number }>, readonly integrity: { readonly __typename?: 'EpocusProgramIntegrity', readonly documented: number, readonly testScans: number, readonly noPatientLink: number, readonly escalationsOpen: number }, readonly turnaroundByReviewer: ReadonlyArray<{ readonly __typename?: 'EpocusReviewerTurnaround', readonly reviewerId: string, readonly name?: string | null, readonly medianMinutes?: number | null, readonly withinTargetPct?: number | null }> } };


export const EpocusProgramDashboardDocument = gql`
    query EpocusProgramDashboard($programId: ID!, $range: EpocusStatsRangeInput!) {
  epocusProgramDashboard(programId: $programId, range: $range) {
    programId
    range {
      from
      to
    }
    priorRange {
      from
      to
    }
    turnaroundTargetMinutes
    scans {
      current
      prior
      deltaPct
    }
    qaReviewedCount
    qaReviewedPct
    completedWithinTargetPct
    openPastTargetCount
    weekly {
      weekStart
      scans
      reviewed
    }
    integrity {
      documented
      testScans
      noPatientLink
      escalationsOpen
    }
    turnaroundByReviewer {
      reviewerId
      name
      medianMinutes
      withinTargetPct
    }
  }
}
    `;

/**
 * __useEpocusProgramDashboardQuery__
 *
 * To run a query within a React component, call `useEpocusProgramDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusProgramDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusProgramDashboardQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      range: // value for 'range'
 *   },
 * });
 */
export function useEpocusProgramDashboardQuery(baseOptions: Apollo.QueryHookOptions<EpocusProgramDashboardQuery, EpocusProgramDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusProgramDashboardQuery, EpocusProgramDashboardQueryVariables>(EpocusProgramDashboardDocument, options);
      }
export function useEpocusProgramDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusProgramDashboardQuery, EpocusProgramDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusProgramDashboardQuery, EpocusProgramDashboardQueryVariables>(EpocusProgramDashboardDocument, options);
        }
export type EpocusProgramDashboardQueryHookResult = ReturnType<typeof useEpocusProgramDashboardQuery>;
export type EpocusProgramDashboardLazyQueryHookResult = ReturnType<typeof useEpocusProgramDashboardLazyQuery>;
export type EpocusProgramDashboardQueryResult = Apollo.QueryResult<EpocusProgramDashboardQuery, EpocusProgramDashboardQueryVariables>;